<form [formGroup]="repForm">
  <div class="row">
    <mat-form-field class="col-6">
      <input
        matInput
        [formControlName]="'repcode'"
        [placeholder]="'Rep Code'"
        [required]="true"
      />
      <mat-error>This field is required</mat-error>
    </mat-form-field>
    <mat-form-field class="col-6">
      <input
        matInput
        [formControlName]="'name'"
        [placeholder]="'Name'"
        [required]="true"
      />
      <mat-error>This field is required</mat-error>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field class="col-6">
      <mat-label>Unit</mat-label>
      <select matNativeControl required [formControlName]="'unitid'">
        @for (unit of unitData; track unit) {
          <option value="{{ unit.id }}">{{ unit.name }}</option>
        }
      </select>
      <mat-error>This field is required</mat-error>
    </mat-form-field>
  </div>
  <div class="row">
    <div class="col-6">
      <button mat-raised-button (click)="save()">Create Rep</button>
    </div>
    <div class="col-6">
      <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
  </div>
</form>
